import { render, staticRenderFns } from "./PatientFilter.vue?vue&type=template&id=e21aef66&scoped=true"
import script from "./PatientFilter.vue?vue&type=script&lang=js"
export * from "./PatientFilter.vue?vue&type=script&lang=js"
import style0 from "./PatientFilter.vue?vue&type=style&index=0&id=e21aef66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e21aef66",
  null
  
)

export default component.exports